import React from 'react'
import styled from "styled-components"
import * as FeatureIcons from '../assets/FeatureIcons'



const FeatureIcon = ({name, style, size}) => {
  const FeatureIcon = FeatureIcons[name]
  if (FeatureIcon) {
    const style = { width: size, height: size }
    return (
      <div>
        <FeatureIcon name={name}>
        </FeatureIcon>
      </div>
    )
  } else {
    return null
  }
}

FeatureIcon.displayName = 'FeatureIcon'

export default  FeatureIcon



// WEBPACK FOOTER //
// ./src/components/FeatureIcon.js